import React, { Component } from 'react';
import Switch from 'react-switch';
import '../../../css/MarketPlace/MyServicesSettings.css';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, servicecatalogBaseURL } from '../../../Services/config/apiGateway';
import {
  SERVICE_ORDER_PREFERENCES_ENDPOINT, SERVICE_TYPES_ENDPOINT
} from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
class MyServicesSettings extends Component {
  constructor() {
    super();
    this.state = {
      sevicesData: [],
      st: {},
      apiStack: []
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillMount() {
    ApiCall(
      'GET',
      servicecatalogBaseURL + SERVICE_TYPES_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((apiData) => {
      if (apiData.flag != -1) {
        if (apiData.flag == 500) {
          console.log('I am 500!');
        }
        else {
          console.log('I am 200!');
          let originalData = apiData;
          apiData = apiData?.map(d => {
            return {
              selectService: false,
              "serviceType": {
                ...d
              }
            }
          })
          this.setState({ sevicesData: apiData });
          ApiCall(
            'GET',
            serviceBaseURL + SERVICE_ORDER_PREFERENCES_ENDPOINT + `?roleType=${this.props.manageProfileDataR?.selectedProfileType}`,
            {},
            {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          ).then((toggleData) => {
            if (toggleData.flag != -1) {
              if (toggleData.flag == 500) {
                console.log('I am 500!');
              } else {
                console.log('I am 200!');
                toggleData = toggleData?.map(td => {
                  return td.serviceType.serviceId
                });
                originalData = originalData?.map(d => {
                  return {
                    selectService: toggleData.includes(d.serviceId),
                    "serviceType": {
                      ...d
                    }
                  }
                })
                this.setState({ sevicesData: originalData });
              }
            }
          });
        }
      }
    });
  }
  handleCustomerSupport = () => {
    this.props.history.push({
      pathname: `/ContactUs`
    })
  }
  toggleSwitchApiCall(selectId, index) {
    var service = !this.state.sevicesData[index]?.selectService;
    var bodyData = this.state.sevicesData;
    for (var i in this.state.sevicesData) {
      if (this.state.sevicesData[i]?.serviceType?.serviceId == selectId) {
        bodyData[i].selectService = service;
        //  break; //Stop this loop, we found it!
      }
    }
    console.log('data', bodyData);
    ApiCall(
      'PUT',
      serviceBaseURL + SERVICE_ORDER_PREFERENCES_ENDPOINT,
      bodyData,
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    ).then((data) => {
      if (data.flag != -1) {
        if (data.flag == 500) {
          console.log('I am 500!');
          for (var i in this.state.sevicesData) {
            if (this.state.sevicesData[i]?.serviceType?.serviceId == selectId) {
              bodyData[i].selectService = !service;
              // break; //Stop this loop, we found it!
            }
          }
          this.setState({ sevicesData: bodyData });
        } else {
          console.log('I am 200!');
        }
      }
      else {
        console.log('Something went wrong!');
      }
    });
  }
  handleChange(checked) {
    this.setState({ checked });
  }
  render() {
    return (
      <div class="csoutercolor">
        <MetaDecorator title={TitleDescription.MyServiceSettingsTitle} description={TitleDescription.MyServiceSettingsDescription} />
        <Header tilesFetched={() => { }} />
        <div class="csnofullServicesSettings">
          <div id="csnobox1ServicesSettings">
            <nav class="ServicesSettingsNavBar">
              <div className="ServicesSettingsNavBarHeading">
                <small id="ServicesSettingsNavBarHeadingValue">My Services</small>
              </div>
            </nav>
            <hr className='navbarhr' />
            <div class="toppartServicesSettings">
              {this.state.sevicesData?.length > 0 &&
                <div class="ServicesSettingsUpperNoteDiv">
                  <small class="ServicesSettingsLowerNote">Enable the services which you can provide.</small>
                </div>
              }
              <div class="ServicesSettingsOuterContainerDiv">
                <div class="ServicesSettingsLeftOuterDiv">
                  {(this.state.sevicesData?.map((s, index) => {
                    return (
                      <div class="ServicesSettingsLeftSideDiv" key={index}>
                        <>
                          <div class="ServicesSettingsWhiteContainerdiv">
                            <div class="ServicesSettingsLeftPartNumberDiv">
                              <small class="ServicesSettingsLeftPartNumber">{index + 1}</small>
                            </div>
                            <div class="ServicesSettingsRightPartContainerDiv">
                              <small class="ServicesSettingsHeading">{s?.serviceType?.serviceName}</small>
                              <div class="ServicesSettingsArrowDiv">
                                <Switch
                                  onChange={() => {
                                    this.toggleSwitchApiCall(s?.serviceType?.serviceId, index)
                                  }}
                                  checked={s?.selectService}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      </div>
                    );
                  }))}
                </div>
              </div>
              <div class="ServicesSettingsLowerNoteDiv">
                <small class="ServicesSettingsLowerNote">Please contact <small class="ServicesSettingsRedNote" onClick={this.handleCustomerSupport}>Customer Support</small> to add new service here.</small>
              </div>
            </div>
          </div>
        </div>
        <div class="cs2footer11ServicesSettings">
          <Footer />
        </div>
        <div class="cs2footer22ServicesSettings">
          <Footer2 />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    manageProfileDataR: state.manageProfileReducer.data
  }
}
export default connect(mapStateToProps)(MyServicesSettings); 